module.exports = __webpack_public_path__ + "img/cil.d1a434a3.png";